import { getFontCss } from '@oberoninternal/travelbase-ds/constants/theme';
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import { SelectedTab } from './pages/My';

export interface TabTitleProp {
    title: ReactNode;
    slug: SelectedTab[number];
    isSelected?: boolean;
}
interface TitleProp {
    setSelectedTab: () => void;
}

const TabNavigationItem: FunctionComponent<React.PropsWithChildren<TabTitleProp & TitleProp>> = ({
    title,
    isSelected,
    setSelectedTab,
}) => (
    <TabItem isSelected={isSelected}>
        <TabButton isSelected={isSelected} onClick={setSelectedTab}>
            {title}
        </TabButton>
    </TabItem>
);

const TabItem = styled.li<{
    isSelected: TabTitleProp['isSelected'];
}>`
    margin-right: 2.4rem;
    padding-bottom: 2.4rem;
    display: flex;
    border-bottom: ${({ isSelected, theme }) => (isSelected ? `2px solid ${theme.colors.primary[80]}` : 'none')};
    ${({ theme }) => getFontCss(theme.fontSizes.body.regular)};
`;

const TabButton = styled.button<{
    isSelected: TabTitleProp['isSelected'];
}>`
    ${({ theme }) => getFontCss(theme.fontSizes.body.regular)};
    color: ${({ isSelected, theme }) => (isSelected ? `${theme.colors.primary[80]}` : theme.colors.neutral[100])};
    cursor: pointer;
    padding: 0;
`;

export default TabNavigationItem;
